document.addEventListener('DOMContentLoaded', function () {
  var visibleCount = 5;
  var section = document.querySelector('.subu-cart-faq');
  if (!section) return;

  var rows = section.querySelectorAll('.accordion');
  if (rows.length <= visibleCount) return;

  var list = section.querySelector('.grid__item');
  if (!list) return;

  for (var i = visibleCount; i < rows.length; i++) {
    rows[i].classList.add('subu-cart-faq__row--hidden');
  }

  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'subu-cart-faq__view-more button button--secondary';
  button.textContent = 'VIEW MORE';
  button.setAttribute('aria-expanded', 'false');

  button.addEventListener('click', function () {
    var expanded = button.getAttribute('aria-expanded') === 'true';
    for (var i = visibleCount; i < rows.length; i++) {
      rows[i].classList.toggle('subu-cart-faq__row--hidden', expanded);
    }
    button.textContent = expanded ? 'VIEW MORE' : 'CLOSE';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });

  list.appendChild(button);
});
